/** @flow */

export const START_MATCH = 'START_MATCH';
export const END_FRAME = 'END_FRAME';
export const POT_RED = 'POT_RED';
export const POT_COLOUR = 'POT_COLOUR';
export const FOUL = 'FOUL';
export const END_VISIT = 'END_VISIT';
export const UNDO = 'UNDO';



// WEBPACK FOOTER //
// ./src/match/MatchActions.js